import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces";

export const selectorIsAllRequirementsComplete = (
  requirements: { status: RequirementStatus }[]
): boolean => {
  if (requirements.length === 0) {
    return true;
  }

  return requirements.every(e => e.status === RequirementStatus.Complete);
};
